export default {
    version: '1.0.0',
    urlsite: document.location.origin+'/eng/',
    app: document.URL.indexOf( 'https://' ) === -1 && document.URL.indexOf( 'https://' ) === -1, 
    uuid: '0123456789',
    onesignal: 'non disponibile',
    platform: (document.URL.indexOf( 'https://' ) === -1 && document.URL.indexOf( 'https://' ) === -1) ? 'app' : 'desktop',
    online: true,
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    screenHeight: screen.height,
    height: window.innerHeight,
    width: screen.width,
    pixelRatio: window.devicePixelRatio,

    mobMmenu:false,

    device: function(){
        if(this.innerWidth>769){
            return "desktop"
        }else if(this.innerWidth<500){
            return "mobile"
        }else{
            return "tablet"
        }
    },

    area: function(){
        return this.height*this.width  
    },

    SortAsc(objToOrder, prop, type) {
        console.log('Sto ordinando in modo crescente per: '+prop)
        if(type=='string'){
           objToOrder.sort(function(a, b){
              if(typeof a[prop]!='string' && typeof b[prop]=='string') return -1 
              if(typeof a[prop]=='string' && typeof b[prop]!='string') return 1 
              if(typeof a[prop]=='string' && typeof b[prop]=='string'){
                 var nameA=a[prop].toString().toLowerCase(), nameB=b[prop].toString().toLowerCase()
                 if (nameA < nameB) return -1 
                 if (nameA > nameB) return 1
              }
              return 0
           })
        }
        if(type=='int'){
           objToOrder.sort(function(a, b){
              var numbA=a[prop]
              var numbB=b[prop]
              return numbA - numbB;
           })
        }
        if(type=='data'){
           objToOrder.sort(function(a, b){
              return new Date(a[prop]) - new Date(b[prop]);
           })
        }
     },
  
     SortDesc(objToOrder, prop, type) {
        console.log('Sto ordinando in modo decrescente per: '+prop)
        if(type=='string'){
           objToOrder.sort(function(a, b){
              if(typeof a[prop]=='string' && typeof b[prop]=='string'){
                 var nameA=a[prop].toLowerCase(), nameB=b[prop].toLowerCase()
                 if (nameA < nameB) return 1 
                 if (nameA > nameB) return -1
              }
              if(typeof a[prop]!='string' && typeof b[prop]=='string') return 1 
              if(typeof a[prop]=='string' && typeof b[prop]!='string') return -1 
              return 0
           })
        }
        if(type=='int'){
           objToOrder.sort(function(a, b){
              var numbA=a[prop]
              var numbB=b[prop]
              return numbB - numbA;
           })
        }
        if(type=='data'){
           objToOrder.sort(function(a, b){
              return new Date(b[prop]) - new Date(a[prop]);
           })
        }
     }
}



// WEBPACK FOOTER //
// ./src/teras.js